import React from "react";

import { DetailsSection } from "../../../DetailsSection/DetailsSection";
import { Step } from "../../../DetailsSection/modules/Step/Step";
import { FEATURE_SECTIONS_STEPS } from "../../constants/EmailSenderUnlockModal.constants";
import { useAccountStore } from "features/Account/store/useAccountStore";

export const FeaturesSection = () => {
  const whitelabelFeatures = useAccountStore(
    (state) => state.whitelabelFeatures
  );
  const FILTERED_STEPS = FEATURE_SECTIONS_STEPS.filter((step) =>
    whitelabelFeatures.includes(step.show)
  );
  return (
    <DetailsSection
      title={
        <>
          You also{" "}
          <span className="tw-text-[#493ab1]">unlock the following</span> with
          this purchase
        </>
      }
    >
      {FILTERED_STEPS.map((step, index) => (
        <Step
          key={step.id}
          {...step}
          isLast={index === FILTERED_STEPS.length - 1}
        />
      ))}
    </DetailsSection>
  );
};
